(function ($) {
    function megaMenu() {
        var target = '.uproar_mega_menu'
        if( $(target).length ) {
            var destination = '.header_wrap nav .mega_menu';
            var destinationMobile = '.mobile_menu .mega_menu';
            $(target).appendTo(destination);
            $(target).clone().appendTo(destinationMobile);

            var links = '.header_wrap .uproar_mega_menu .menu_links li';
            var images = '.header_wrap .uproar_mega_menu .menu_images li';

            $(images).first().addClass('active');
            $(links).each(function(index, element) {
                if(index === 0) {
                    $(element).addClass('active');
                }
                $(element).hover(function() {
                    $(element).siblings().removeClass('active');
                    $(element).addClass('active');
                    $(images).each(function(index2, element2) {
                        if(index2 === index) {
                            $(element2).siblings().removeClass('active');
                            $(element2).addClass('active');
                        }
                    });
                });
            });
        }
    }

    function kolisiSpecs() {
        var target = '.uproar_kolisi_specs';
        if( $(target).length ) {
            var images = $(target).find('.variant_images .variant_image');
            var variants = $(target).find('.variants .variant');

            $(images).first().addClass('active');
            $(variants).first().addClass('active');

            var i = 0;
            var specs_button = $('#specs_button');
            var final_cta_button = $('#final_cta_button');

            $(variants).each(function(index, element) {
                i++;

                // set the default add to cart link to first variant
                if (i == 1){
                    var cart_url = $(specs_button).data('href');
                    var variant_id = $(element).data('id');
                    specs_button.attr('href', cart_url + variant_id);
                    final_cta_button.attr('href', cart_url + variant_id);
                }

                $(element).click(function(e) {
                    e.preventDefault();
                    $(element).siblings().removeClass('active');
                    $(element).addClass('active');
                    
                    // set the add to cart link when link
                    var cart_url = $(specs_button).data('href');
                    var variant_id = $(element).data('id');
                    specs_button.attr('href', cart_url + variant_id);
                    final_cta_button.attr('href', cart_url + variant_id);

                    $(images).each(function(index2, element2) {
                        if(index2 === index) {
                            $(element2).siblings().removeClass('active');
                            $(element2).addClass('active');
                        }
                    });
                })
            });
        }
    }

    function owlCarousel() {
        // FEATURED PROJECTS
        $(".owl-carousel.carousel_featured_projects").owlCarousel({
            loop:true,
            margin:10,
            autoplayTimeout:5000,
            nav:true,
            dots:false,
            navContainer: '.carousel_nav',
            responsive:{
                1:{
                    items:1
                },
                767:{
                    items:3
                }
            }
        });

        // TESTIMONIALS
        $(".owl-carousel.carousel_testimonials").owlCarousel({
            loop:true,
            autoPlay:true,
            autoplayTimeout:5000,
            nav:true,
            dots:false,
            items:1,    
            navText: ["<span class='prev'></span>","<span class='next'></span>"]
        });

        // TESTIMONIALS
        $(".owl-carousel.carousel_mobilewhy").owlCarousel({
            loop:true,
            autoPlay:true,
            autoplayTimeout:5000,
            nav:true,
            dots:false,
            items:1,    
            navText: ["<span class='prev'></span>","<span class='next'></span>"]
        });
    }

    function mobileMenu() {
        // var target = '.mobile_menu_toggle';
        // $(target).on('click', function() {
        //     $('body').toggleClass('mobile_menu_open');
        // });
    }

    function navigationjQuery() {
        var target = $('nav.main-nav .parent-menu-item');

        if (target.length) {
            target.each(function( index ) {
                 if ($(this).find('.grandchild').length) {
                    $(this).addClass('big-menu');

                    var res = ($(window).width()/100) * 15;
                    var width = $(window).width() - res;
                    var res1 = ($(window).width()/100) * (-25);

                    if ($(window).width() < 1255) {
                        $(this).find('.child-menu').attr('style', 'left:0px!important;' + 'width: 100%!important;min-width: fit-content!important;');
                    }
                    else {
                        $(this).find('.child-menu').attr('style', 'left:' + res1 + 'px!important;' + 'width:' + width + 'px!important;');
                    }
                 }
            });
        }

        var target = $('nav.mobile-main-nav .parent-menu-item');

        if (target.length) {
            target.each(function( index ) {
                 if ($(this).find('.grandchild').length) {
                    $(this).addClass('big-menu-mobile');
                 }
            });
        }
    }

    function mobileNavigation() {
        var target = $('.mobile-main-nav');
        var targetbtn = $('.mobile_menu_toggle');
        var targetarrowdown = $('.mobile-main-nav .arrow-mobile');
        var targetarrowdown2 = $('.mobile-main-nav .arrow-down-mobile');

        if ( target.length ) {
            targetbtn.click(function(){
                target.slideToggle('slow');
                $(this).toggleClass('open');
                $('html').toggleClass('mobile-open')
                // target.toggleClass('mobilepadding')
            });      
            
            targetarrowdown.click(function(){
                $(this).parent().find('.mobile-child-menu').slideToggle('slow');
                $(this).parent().find('.arrow-down-mobile').toggleClass('mm-cross');                
                if ($(this).hasClass('nav--open')) {
                    window.location.href = $(this).data("url");                  
                }
                $(this).addClass('nav--open');
            }); 

            targetarrowdown2.click(function(){
                $(this).parent().find('.mobile-child-menu').slideToggle('slow');
                if ($(this).hasClass('mm-cross')) {
                    $(this).parent().find('.arrow-mobile').removeClass('nav--open');
                }
                else {
                    $(this).parent().find('.arrow-mobile').addClass('nav--open');
                }
                $(this).parent().find('.arrow-down-mobile').toggleClass('mm-cross');                
            });
        }        
    }

    function shopallfilters(){
        var targetfilter1 = $('#FilterTags');
        var targetfilter2 = $('#SortBy');
        
        if (targetfilter1.length) {            
            targetfilter1.change(function(){
                shopfilter($(this).val() , targetfilter2.val())
            })
        }
        if (targetfilter2.length) {            
            targetfilter2.change(function(){
                shopfilter(targetfilter1.val() , $(this).val() )
            })
        }

        function shopfilter(filter1,filter2) {
            var filter = '';
            if(filter1 == undefined) {
                filter1 = targetfilter2.data("default-collection");          
            }
            else {
                filter1 = filter1;
            }
            if(filter2 == undefined) {
                filter2 = '';
            }
            else {
                filter2 = '?sort_by=' + filter2;
            }
            filter = filter1 + '' + filter2;
            
            console.log(filter);
            window.location.replace(filter);
        }
    }

    function shopallfiltersMobile(){
        var targetfilter1 = $('#FilterTagsMobile');
        var targetfilter2 = $('#SortByMobile');
        
        if (targetfilter1.length) {            
            targetfilter1.change(function(){
                shopfilterMobile($(this).val() , targetfilter2.val())
            })
        }
        if (targetfilter2.length) {            
            targetfilter2.change(function(){
                shopfilterMobile(targetfilter1.val() , $(this).val() )
            })
        }

        function shopfilterMobile(filter1,filter2) {
            var filter = '';
            if(filter1 == undefined) {
                filter1 = targetfilter2.data("default-collection");          
            }
            else {
                filter1 = filter1;
            }
            if(filter2 == undefined) {
                filter2 = '';
            }
            else {
                filter2 = '?sort_by=' + filter2;
            }
            filter = filter1 + '' + filter2;
            
            console.log(filter);
            window.location.replace(filter);
        }
    }

    function collectionpagination() {
        var target = $('.pagination');

        if (target.length) {
            target.find('.prev a').text('');
            target.find('.next a').text('');
            target.find('.deco').text('.....');

            // if (target.find('.next').length) {
            //     $("<span class='slash'>/</span>").insertAfter(".page.current");
            // }            
            // else {
            //     $("<span class='slash' style='visibility: hidden'>/</span>").insertAfter(".page.current");
            // }

            // target.find('.page.current').text('');


            // target.find('.page.current').append($('#pagination-drop').clone().get(0).outerHTML);


            // $('#pagination-drop').change(function () {
            //     console.log($(this).find(":selected").data("url"));
            //     window.location.href = $(this).find(":selected").data("url");    
            // });

            
            console.log($('#pagination-drop'));

        }


    }

    function productSlider() {
        var target = $('.product-slider-wrap .main-slider');
        var thumbSlider = $('.product-slider-wrap .thumb-slider');

        if (target.length) {
            target.slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                arrows: false,
                asNavFor: '.thumb-slider'
            });
        }

        if (thumbSlider.length) {

            thumbSlider.slick({
                dots: false,
                infinite: true,
                speed: 300,
                arrows: false,
                vertical: false,
                verticalSwiping: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: '.main-slider',
                focusOnSelect: true,
                draggable: true,
            });

        }
    }

    function productRecomSlider() {
        $('.carousel_recommendation').owlCarousel({
            loop:true,
            autoPlay:true,
            autoplayTimeout:5000,
            nav:true,
            dots:false,
            items:3,    
            mouseDrag: false,
            navText: ["<span class='prev'></span>","<span class='next'></span>"],
            responsive : {
                // breakpoint from 0 up
                0 : {
                    items : 1,
                    nav:false,
                },
                900 : {
                    items : 2,
                },
                1200 : {
                    items : 3,
                }
            }
        });
    }

    function quantitySelector() {
        var target = $('.row-add-cart');

        target.each(function( index ) {
            $(this).find('.quantity .minus').click(function () {
                var $input = $(this).parent().find('.qty');
                var count = parseInt($input.val()) - 1;
                count = count < 1 ? 1 : count;
                $input.val(count);
                $input.change();
                return false;
            });
            $(this).find('.quantity .plus').click(function () {
                var $input = $(this).parent().find('.qty');
                $input.val(parseInt($input.val()) + 1);
                $input.change();
                return false;
            }); 
        });
    }

    function addresstogglebuttons() {
        var target = $('.address_row ');

        if(target.length) {
            target.find('.add-address-toggle').click(function () {
                target.find('.add-address-form').fadeToggle();

                target.find('select#AddressCountryNew').val("Australia");
                target.find('select#AddressCountryNew').trigger('change');
            });

            target.find('.cancel-toggle').click(function () {
                target.find('.add-address-form').fadeOut();
            });

            target.find('select#AddressCountryNew').change(function () {
                target.find('#AddressProvinceNew').empty();
                if($(this).find(':selected').data('provinces').length) {
                    if(target.find('#AddressProvinceNew').length) {
                        for (let i = 0; i <  $(this).find(':selected').data('provinces').length; i++) {
                            console.log($(this).find(':selected').data('provinces')[i][0]);
                            target.find('#AddressProvinceNew').append('<option value="'+ $(this).find(':selected').data('provinces')[i][0] +'"> '+ $(this).find(':selected').data('provinces')[i][1] +'</option>');
                        }                                              
                    }    
                    target.find('#AddressProvinceNewContainer').removeClass('d-none');                  
                }
                else {
                    target.find('#AddressProvinceNewContainer').addClass('d-none');
                }

            });

            var editformtarget = $('.edit-address-form');

            target.find('.edit-address-toggle').click(function () {
                target.find('.edit-address-form').fadeToggle();
            
                editformtarget.find('.address-country-option').val(editformtarget.find('.address-country-option').data('default'));
                editformtarget.find('select[name="address[country]"]').trigger('change');
            });

            target.find('.cancel-address-toggle').click(function () {
                target.find('.edit-address-form').fadeOut();
            });

            editformtarget.find('select[name="address[country]"]').change(function () {
                editformtarget.find('select[name="address[province]"]').empty();

                if($(this).find(':selected').data('provinces').length) {
                    if(editformtarget.find('select[name="address[province]"]').length) {
                        for (let i = 0; i <  $(this).find(':selected').data('provinces').length; i++) {                            
                            editformtarget.find('select[name="address[province]"]').append('<option value="'+ $(this).find(':selected').data('provinces')[i][0] +'"> '+ $(this).find(':selected').data('provinces')[i][1] +'</option>');

                            if ($(this).find(':selected').data('provinces')[i][0] == editformtarget.find('select[name="address[province]"]').data('default')) {
                                editformtarget.find('select[name="address[province]"]').val(editformtarget.find('select[name="address[province]"]').data('default'));                  
                            } 
                        }                                                                                       
                    }    
                    editformtarget.find('#AddressProvinceNewContainerEdit').removeClass('d-none');                  
                }
                else {
                    editformtarget.find('#AddressProvinceNewContainerEdit').addClass('d-none');
                }
            });

            
        }
    }

    function logintoggles() {
        var target = $('.login_row');

        if (target.length) {
            target.find('.forgot-form-toggle').click(function () {
                target.find('.forget-form').fadeToggle();
                target.find('.login-form').fadeToggle();
            });

            target.find('.cancel-button').click(function () {
                target.find('.forget-form').fadeToggle();
                target.find('.login-form').fadeToggle();
            });

            if(window.location.hash) {
                if (window.location.hash == '#recover') {
                    target.find('.forget-form').fadeIn();
                    target.find('.login-form').fadeOut();
                }
            } 
        }
    }

    function cartscripts() {
        var target = $('.row_cart .td-quantity');

        target.each(function( index ) {
            $(this).find('.quantity .minus').click(function () {
                var $input = $(this).parent().find('.qty');
                var count = parseInt($input.val()) - 1;
                count = count < 1 ? 1 : count;
                $input.val(count);
                $input.change();
                return false;
            });
            $(this).find('.quantity .plus').click(function () {
                var $input = $(this).parent().find('.qty');
                $input.val(parseInt($input.val()) + 1);
                $input.change();
                return false;
            }); 
        });

        var ifloggedin = $('.row_cart')

        if(ifloggedin.length) {
            if (ifloggedin.find('.not-logged-in').length) {
                
                $('<a href="/discount/REMOVE_DISCOUNT?redirect=/checkout" class="button" type="submit" name="checkout" value="Check Out">Check Out</a>').insertBefore(ifloggedin.find('input[name="checkout"]'));
                ifloggedin.find('input[name="checkout"]').remove();

                // ifloggedin.find('input[name="checkout"]').click(function () {
                //     console.log(1);
                //     window.location.href = '/discount/REMOVE_DISCOUNT?redirect=/checkout';
                // })
            }
        }

    }

    
    function searchbar() {
        /// Main search input
        $('#pageheader .search-box input[type="text"]').bind('focusin focusout', function(e){
            $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
        });
        

        /// Live search
        var preLoadLoadGif = $('<img src="//thegreenshedflowers.com.au/cdn/shop/t/23/assets/ajax-load.gif?v=4431" />');
        var searchTimeoutThrottle = 500;
        var searchTimeoutID = -1;
        var currReqObj = null;
        var $resultsBox = $('<div class="results-box" />').appendTo('#pageheader .search-box');
        $('#pageheader .search-box input[type="text"]').bind('keyup change', function(){
            //Only search if search string longer than 2, and it has changed
        if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
                //Reset previous value
                $(this).data('oldval', $(this).val());
                
                // Kill outstanding ajax request
                if(currReqObj != null) currReqObj.abort();
                
                // Kill previous search
                clearTimeout(searchTimeoutID);
            
                var $form = $(this).closest('form');
            
                //Search term
                var term = '*' + $form.find('input[name="q"]').val() + '*';
                
                //URL for full search page
                var linkURL = $form.attr('action') + '?type=product&q=' + term;
                
                //Show loading
                $resultsBox.html('<div class="load"></div>');
                
                // Do next search (in X milliseconds)
                searchTimeoutID = setTimeout(function(){
                    //Ajax hit on search page
                    currReqObj = $.ajax({
                    url: $form.attr('action'),
                    data: {
                        type: 'product',
                        view: 'json',
                        q: term,
                    },
                    dataType: "json",
                    success: function(data){
                            currReqObj = null;
                            if(data.results_total == 0) {
                                //No results
                                $resultsBox.html('<div class="note">'+ "Translation missing: en.layout.live_search.no_results" +'</div>');
                            } else {
                                //Numerous results
                                $resultsBox.empty();
                                $resultsBox.append('<h3>Products </h3>');
                                $.each(data.results, function(index, item){
                                    var xshow = 'wholesale'; //term for products we dont want to show
                                    if(!(item.title.toLowerCase().indexOf(xshow) > -1)) {
                                    var $row = $('<a></a>').attr('href', item.url);
                                    $row.append('<div class="img"><img src="' + item.thumb + '" /></div>');
                                    $row.append('<div class="d-title">'+item.title+'</div>');
                                    $resultsBox.append($row);
                                    }
                                });
                                $resultsBox.append('<a href="' + linkURL + '" class="note"> Search for "' + $form.find('input[name="q"]').val() + '" </a>');
                            }
                    }
                    });
                }, searchTimeoutThrottle);
            } else if ($(this).val().length <= 2) {
                //Deleted text? Clear results
                $resultsBox.empty();
            }
        }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
            //Focus, show results
            $resultsBox.fadeIn(200);
        }).bind('click', function(e){
            //Click, prevent body from receiving click event
            e.stopPropagation();
        });
        $('body').bind('click', function(){
            //Click anywhere on page, hide results
            $resultsBox.fadeOut(200);
        });
    
        //Search box should mimic live search string: products only, partial match
        $('.search-form, #search-form').on('submit', function(e){
        e.preventDefault();
        var term = '*' + $(this).find('input[name="q"]').val() + '*';
        var linkURL = $(this).attr('action') + '?type=product&q=' + term;
        window.location = linkURL;
        });

        // search ends
    }

    function wishlistscript() {
        //  if (localStorage.getItem('shopify-wishlist').length) {

        //  }
    } 

    function scrollClass() {
        function checkScroll() {
            var scroll = $(window).scrollTop();
            if (scroll >= 10) {
                $('body').addClass('sticky');
            } else {
                $('body').removeClass('sticky');
            }
        }
        checkScroll();
        $(window).scroll(function() {
            checkScroll();
        });
    }

    function popupscript() {
        var target = $('.popup-section');

        if (target.length) {
            var seconds  = target.find('.popup-delay').text();
            var days  = target.find('.popup-days').text();

            var d = new Date();
            var month = d.getMonth()+1;
            var day = d.getDate();

        
            var output = d.getFullYear() + '/' + ((''+month).length<2 ? '0' : '') + month + '/' +  ((''+day).length<2 ? '0' : '') + day;
            console.log(output);

            localStorage.setItem('modalday', output); 
            
            if (seconds > 0) {
                setTimeout(
                function() {
                    if (localStorage.getItem('modaldayexpires') == undefined  ) {
                        target.find('#modal-popup').modal('show');
                    }
                    if (localStorage.getItem('modaldayexpires') <= output  ) {
                        target.find('#modal-popup').modal('show');
                    }   

                }, seconds * 1000); 
            }

            target.find('#modal-popup').on('hidden.bs.modal', function (e) {
                var tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + parseInt(days));
                var month2 = tomorrow.getMonth()+1;
                var day2 = tomorrow.getDate();

                var output2 = tomorrow.getFullYear() + '/' + ((''+month2).length<2 ? '0' : '') + month2 + '/' +  ((''+day2).length<2 ? '0' : '') + day2;
                
                console.log(output2);
                localStorage.setItem('modaldayexpires', output2); 
            })
                        
        }
    }

    function pricingScript() {
        var target = $('.__hide-pricing');
        var loggedin = $('.user-logged-in');
        
        if (target.length) {
            $('.product-price').each(function(){
                $(this).text('Login for Pricing');
                $(this).css('color','#d59588');
            });    
        }
        if (loggedin.length) {
            var percentage = $('.js-form-discount-percentage');
            $('.product-price .actual-price').each(function(){
                
                const main = $.trim($(this).text()).substring(1).split(" ");                
                var dec = (percentage.val() / 100).toFixed(2); 

                // console.log();
                if ( isNaN(parseFloat(main[0])) )  {
                    var mult = parseFloat($(this).closest('.product-price').attr('data-price').substring(1)) * dec; 
                    var discont = parseFloat($(this).closest('.product-price').attr('data-price').substring(1)) - mult;
                    // console.log(1);
                }
                else {
                    var mult = main[0] * dec; 
                    var discont = main[0] - mult;
                    // console.log(2);
                }
                

                if (main.length > 1) {    
                    // $(this).text("$" + discont.toFixed(2) + " " + main[main.length - 2] + " " + main[main.length - 1]);
                    $(this).text("$" + discont.toFixed(2));
                }
                else {
                    $(this).text("$" + discont.toFixed(2));
                }        
                
                console.log(discont.toFixed(2));
                console.log(main[main.length - 2]);
                console.log(main[main.length - 1]);
                // console.log(discont);
                // console.log(main);
            }); 

            $('.td-quantity .qty-price').each(function(){
                
                const main = $.trim($(this).text()).substring(1).split(" ");                
                var dec = (percentage.val() / 100).toFixed(2); 

                if ( isNaN(parseFloat(main[0])) )  {
                    var mult = parseFloat($(this).closest('.product-price').attr('data-price').substring(1)) * dec; 
                    var discont = parseFloat($(this).closest('.product-price').attr('data-price').substring(1)) - mult;
                }
                else {
                    var mult = main[0] * dec; 
                    var discont = main[0] - mult;
                }
                

                if (main.length > 1) {    
                    $(this).text("$" + discont.toFixed(2));
                }
                else {
                    $(this).text("$" + discont.toFixed(2));
                }        
                
            });

            $('.subtotal-amount').each(function(){
                const main = $.trim($(this).text()).substring(1).split(" ");
                var dec = (percentage.val() / 100).toFixed(2); 
                var mult = main[0] * dec; 
                var discont = main[0] - mult;

                if (main.length > 1) {    
                    $(this).text("$" + discont.toFixed(2) + " " + main[main.length - 2] + " " + main[main.length - 1]);
                }
                else {
                    $(this).text("$" + discont.toFixed(2));
                } 
            });     
        }

        $(".product-price").fadeIn();
        $(".subtotal-amount").fadeIn();    
    }

    function collectionaddtocartajax() {
        var card_buttons;
        var card_buttons_img;

        $('.card-buttons').each(function(){
            card_buttons = $(this);
            $(this).find('.add-to-cart-form').on('submit', function(event) {
                event.preventDefault(); // prevent default form submission
                // event.stopPropagation();
                var self = this;
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: $(this).serialize(),
                    dataType: 'json',
                    success: function() {
                        vError = 0;

                      $(self).parent().parent().parent().find('.cart-error').text("");
                        $(self).parent().parent().parent().find('.cart-added').fadeIn(1000, function(){
                            $(self).parent().parent().parent().find('.cart-added').fadeOut(1000);
                        })

                        setTimeout(function() { 
                            $.ajax({
                                type: 'GET',
                                url: '/cart.js',
                                dataType: 'json',
                                success: function(data) { 
                                    var item_count = data['item_count'];
                                    //If there are items in cart
                                    if(item_count > 0) {
                                        //do stuff
                                        if(item_count < 9) {
                                            $('.header_top .links .cart .cart-number').text(item_count);
                                        }
                                        else {
                                            $('.header_top .links .cart .cart-number').text('9+');
                                        }
                                    }
                                }
                            });
                        }, 500);
                    },
                    error: function(data) {
                        // Do something on error (e.g. show an error message)
                        // $(self).parent().parent().parent().find('.cart-error').fadeIn(1000, function(){
                            $(self).parent().parent().parent().find('.cart-error').text(data.responseJSON.description);
                        //})
                    }
                });

            });
        });

        $('.product-card .img-container').each(function(){
            card_buttons_img = $(this);
            $(this).find('.add-to-cart-form-img').on('submit', function(event) {
                event.preventDefault(); // prevent default form submission
                var self = this;
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: $(this).serialize(),
                    dataType: 'json',
                    success: function() {
                      $(self).parent().parent().parent().parent().find('.cart-error').text("");
                        $(self).parent().parent().parent().parent().find('.cart-added').fadeIn(1000, function(){
                            $(self).parent().parent().parent().parent().find('.cart-added').fadeOut(1000);
                        })

                        setTimeout(function() { 
                            $.ajax({
                                type: 'GET',
                                url: '/cart.js',
                                dataType: 'json',
                                success: function(data) { 
                                    var item_count = data['item_count'];
                                    //If there are items in cart
                                    if(item_count > 0) {
                                        //do stuff
                                        if(item_count < 9) {
                                            $('.header_top .links .cart .cart-number').text(item_count);
                                        }
                                        else {
                                            $('.header_top .links .cart .cart-number').text('9+');
                                        }
                                    }
                                }
                            });
                        }, 500);
                    },
                    error: function(data) {
                    // Do something on error (e.g. show an error message)
                        $(self).parent().parent().parent().parent().find('.cart-error').text(data.responseJSON.description);
                                      
                    }
                });

                //console.log( $(this).parent().parent().parent().parent());

            });
        });
    }

    function recomcollectionaddtocartajax() {
        var target = $('.row_prod-recom');

        if (target.length) {
            $('.site-item').each(function(){
                $(this).find('.shopify-product-form').on('submit', function(event) {
                    var self = this;
                    event.preventDefault(); // prevent default form submission
                    
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: $(this).serialize(),
                        dataType: 'json',
                        success: function() {
                            // Do something on success (e.g. show a success message)
                          $(self).parent().find('.cart-error').text("");
                            $(self).parent().find('.cart-added').fadeIn(1000, function(){
                                 $(self).parent().find('.cart-added').fadeOut(1000);
                            })

                            setTimeout(function() { 
                                $.ajax({
                                    type: 'GET',
                                    url: '/cart.js',
                                    dataType: 'json',
                                    success: function(data) { 
                                        var item_count = data['item_count'];
                                        //If there are items in cart
                                        if(item_count > 0) {
                                            //do stuff
                                            if(item_count < 9) {
                                                $('.header_top .links .cart .cart-number').text(item_count);
                                            }
                                            else {
                                                $('.header_top .links .cart .cart-number').text('9+');
                                            }
                                        }
                                    }
                                });
                            }, 500);
                        },
                        error: function(data) {
                        // Do something on error (e.g. show an error message)
                            //console.log(2);
                            $(self).parent().find('.cart-error').text(data.responseJSON.description);
                        }
                    });

                    // console.log( $(this).parent());
                    // $(this).parent().find('.cart-added').fadeIn(1000, function(){
                    //     $(this).parent().find('.cart-added').fadeOut(1000);
                    // })
                });
            });
        }        
    }

    function productaddtocartajax() {
        var target = $('.col-summary');

        if (target.length) {
            target.find('.shopify-product-form').on('submit', function(event) {
                var self = this; 
                event.preventDefault(); // prevent default form submission
                $('.col-summary .add-btn .cart-loading').removeClass('hidden');
                $('.col-summary .add-btn .cart-text').addClass('hidden');
                
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: $(this).serialize(),
                    dataType: 'json',
                    success: function() {
                    // Do something on success (e.g. show a success message)
                        //console.log(1);

                        $(self).find('.cart-error').text('');
                        $('.col-summary .add-btn .cart-loading').addClass('hidden');
                        $('.col-summary .add-btn .cart-text').removeClass('hidden');
                        $('#productAddtoCartModal').modal('show');           
                        $('#productAddtoCartModal').find('.cart-popup-item__image').attr('src',$('.col-slide .drift-img').attr('src')); 
                        $('#productAddtoCartModal').find('.cart-popup-item__title').text($('.col-summary .product-name').text())
                        $('#productAddtoCartModal').find('.cart-popup-item__quantity .qty_number').text($('.col-summary #Quantity').val())
                        
                        // .src = $('.col-slide .drift-img').src ;
                        setTimeout(function() { 
                            $.ajax({
                                type: 'GET',
                                url: '/cart.js',
                                dataType: 'json',
                                success: function(data) { 
                                    var item_count = data['item_count'];
                                    //If there are items in cart
                                    if(item_count > 0) {
                                        //do stuff
                                        if(item_count < 9) {
                                            $('.header_top .links .cart .cart-number').text(item_count);
                                        }
                                        else {
                                            $('.header_top .links .cart .cart-number').text('9+');
                                        }
                                    }
                                }
                            });
                        }, 500);
                        
                    },
                    error: function(data) {
                        // Do something on error (e.g. show an error message)
                        //console.log(2);
                        $('.col-summary .add-btn .cart-loading').addClass('hidden');
                        $('.col-summary .add-btn .cart-text').removeClass('hidden');
                        $(self).find('.cart-error').text(data.responseJSON.description);
                        
                    }
                });


            });
        }
    }

    function cartTracker() {
        var row_cart = $(".row_cart");
        

        if (row_cart.length) {

            if ( row_cart.find('.responsive-table').length ) {

                row_cart.find('.discount-banner').fadeIn();
                row_cart.find('.discount-banner .paragraph').hide();

                row_cart.find('.discount-banner .button.find').click(function() {

                    var amountspend;

                    if ( row_cart.find('.postal').val() >= 6000 && row_cart.find('.postal').val() <= 6199) {
                        console.log('Perth Metro');
                        amountspend = row_cart.find('.discount-banner .hidden-value').val();
                    }
                    else {
                        console.log('Rest of AU');
                        amountspend = row_cart.find('.discount-banner .hidden-value-au').val()
                    }

                    const bmain = $.trim(row_cart.find('.subtotal-amount').text()).substring(1).split(" ");

                    console.log(isNaN(parseFloat(bmain)));

                    if ( isNaN(parseFloat(bmain)) == false) {

                        if (parseFloat(amountspend) > parseFloat(bmain[0]) ) {
                            row_cart.find('.discount-banner .amount').text(parseFloat(parseFloat(amountspend) - parseFloat(bmain[0])).toFixed(2) );                
                        }
                        else {
                            row_cart.find('.discount-banner .paragraph').text(' Congrats! You have free shipping');            
                        }
                        
                    }

                    row_cart.find('.discount-banner .full-amount-new').text('$' + parseFloat(amountspend));
                    row_cart.find('.discount-banner .paragraph').show();
                });
            }
        }
    }

    function AddtoCartText() {
        if ($(window).width() < 601) {
                $('.card-buttons').each(function(){
                    $(this).find('.btn-add').val('ADD TO CART')
                });
            }
            else {
                $('.card-buttons').each(function(){
                    $(this).find('.btn-add').val('CART')
                });
            }
    }

    function BulkaddtoCart() {
        var target = $('.row_page_collection');

        var targetPopup = $('.popup-modalBulk');

        if (target.length) {


            var proceed = 1;

            target.append("<button class='btn-bulk-button'>BULK ADD TO CART</button>");

            target.find('.btn-bulk-button').click(function() {

                target.find('.product-card.bulk-collection-card').each(function(){
                    console.log($(this).find('.qty').val())
                    if ($(this).find('.qty').val() > 0  ) {
                        proceed = 1;
                        return false;
                    }
                    else {
                        proceed = 0;
                    }
                });

                console.log(proceed);
                if (proceed == 0) {
                    targetPopup.find('#modal-popupBulk').removeClass('bulkloading');
                    targetPopup.find('#modal-popupBulk').modal('show');
                    targetPopup.find('#modal-popupBulk .modal-title').text('Please Enter a number');
                    targetPopup.find('#modal-popupBulk .modal-body p').text('Please select a number of items to purchase or choose product options.');
                }
                else {
                    targetPopup.find('#modal-popupBulk').modal('show');
                    targetPopup.find('#modal-popupBulk').addClass('bulkloading');

                    var jsonObj = {
                        "items":[]
                    }; 
                    
                    target.find('.product-card.bulk-collection-card').each(function(){
                        
                        if ($(this).find('.qty').val() > 0 ) {
                            console.log('Processing Loop' + $(this).find('.qty').val())
                            var items = {}
                            items.id = $(this).attr('data-product-id'); 
                            items.quantity =  $(this).find('.qty').val(); 
                            jsonObj.items.push(items);
                        }
                    });

                    console.log(jsonObj)

                    jQuery.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: jsonObj,
                        dataType: 'json',
                        success: function() { 
                            setTimeout(function() { 
                                $.ajax({
                                    type: 'GET',
                                    url: '/cart.js',
                                    dataType: 'json',
                                    success: function(data) { 
                                        var item_count = data['item_count'];
                                        //If there are items in cart
                                        if(item_count > 0) {
                                            //do stuff
                                            if(item_count < 9) {
                                                $('.header_top .links .cart .cart-number').text(item_count);
                                            }
                                            else {
                                                $('.header_top .links .cart .cart-number').text('9+');
                                            }
                                        }
                                    }
                                });
                            }, 500);

                            targetPopup.find('#modal-popupBulk').removeClass('bulkloading');
                            targetPopup.find('#modal-popupBulk .modal-title').text('Items have been added to your cart');
                            targetPopup.find('#modal-popupBulk .modal-body p').text('All selected items added to cart.');
                            console.log('success');      
                        },
                        error: function(data) { 
                            targetPopup.find('#modal-popupBulk').removeClass('bulkloading');
                            targetPopup.find('#modal-popupBulk .modal-title').text('Error');
                            targetPopup.find('#modal-popupBulk .modal-body p').text(data.responseJSON.description);
                            console.log(data.responseJSON.description);
                        }
                    });
                }
            });
        }
    }

    function meetTheTeam() {     
      var target = $('.uproar_row.row_page_about');

      if (target.length) {
        var hash = window.location.hash;

        var container = $('html, body'),
            scrollTo = $('#shopify-section-uproar-page-about'),
            heightoffset = 139,
            scrollLocation = scrollTo.offset().top - heightoffset;

        $(".desktop").on("click", ".parent-menu-item.active .child-menu li.child-item", function(event){
          // console.log(1);
           container.animate({
              scrollTop: scrollLocation
          }, 1000);
        });

        $(".mobile-main-nav").on("click", ".parent-menu-item.active .mobile-child-menu li.child-item", function(event){
          // console.log(1);
           container.animate({
              scrollTop: scrollLocation - 120
          }, 1000);
        });
        
        if (hash == '#meet-the-team') {          
          container.animate({
              scrollTop: scrollLocation
          }, 1000);
          
        }
      }
    }

  function ChangeAddtoListText() {
        var target = $('.wishlist__grid');
        
        if (target.length) {
            target.find('.product-card').each(function(){
               console.log(1);
                $(this).find('.button-wishlist').click(function(e) {

                  setTimeout(
                  function() {
                      pricingScript();
                  }, 2000); 
   
                });
            });
        }
    }

  function quantityContainer() {
        var target = $('.row_page_collection');

        if ( target.length ) {
            target.find('.site-item').each(function(){
                var self = $(this)
                $(this).find('.quantity-container .qty').bind('keyup mouseup', function () {
                    console.log($(this).val());
                    self.find('.card-buttons .add-to-cart-form #quantity').val($(this).val())   
                });
            });
        }
    }

  function preFillQuantities() {
      var target = '.template-collection .product-card input';
      if( target.length ) {
        setTimeout(function() {
          $(target).each(function(index,element) {
            $(element).val('1').prop("value", "1");
          });
        },3000)
      }
  }

    $(document).ready(function () {
        megaMenu();
        owlCarousel();
        mobileMenu();
        kolisiSpecs();
        navigationjQuery();
        mobileNavigation();       
        shopallfilters();
        shopallfiltersMobile();        
        collectionpagination();
        productSlider();
        addresstogglebuttons();
        logintoggles();
        cartscripts();
        searchbar();
        wishlistscript();
        scrollClass();
        popupscript();    
        productaddtocartajax();
        AddtoCartText();
        BulkaddtoCart();
        meetTheTeam();
        quantityContainer();
        preFillQuantities();
        setTimeout(
        function() {
            $(".main-nav .fas").fadeIn();
        }, 500);  
        
        setTimeout(
        function() {
            productRecomSlider();
            quantitySelector();
            pricingScript();
            collectionaddtocartajax();
            recomcollectionaddtocartajax();
            cartTracker();
            ChangeAddtoListText();
        }, 2000);     

       
    });

    $(window).on('resize', function(){
        var target = $('nav.main-nav .parent-menu-item');
        var win = $(this);
        if (target.length) {
            target.each(function( index ) {
                if ($(this).find('.grandchild').length) {                       
                    var res = ($(window).width()/100) * 15;
                    var width = $(window).width() - res;
                    var res1 = ($(window).width()/100) * (-35);                    

                    if ($(window).width() < 1255) {
                        $(this).find('.child-menu').attr('style', 'left:0px!important;' + 'width: 100%!important;min-width: fit-content!important;');
                    }
                    else {
                        $(this).find('.child-menu').attr('style', 'left:' + res1 + 'px!important;' + 'width:' + width + 'px!important;');
                    }

                }
            });
        }
                
        if ($(window).width() > 749) {
            var targetbtn = $('.button-nav.open');
            var target = $('.mobile-main-nav');

            if (targetbtn.length) {
                targetbtn.removeClass('open');                    
                target.slideToggle('slow');
            }
        }

        if ($(window).width() < 601) {
            $('.card-buttons').each(function(){
                $(this).find('.btn-add').val('ADD TO CART')
            });
        }
        else {
            $('.card-buttons').each(function(){
                $(this).find('.btn-add').val('CART')
            });
        }
    });

}(window.jQuery || window.$));